import { Platform } from "@-/com.npmjs.react-native";
import Animated from "@-/com.npmjs.react-native-reanimated";

/**
 * This component is used to wrap animated views that should only be animated on native.
 * @param props - The props for the animated view.
 * @returns The animated view if the platform is native, otherwise the children.
 * @example
 * <NativeOnlyAnimatedView entering={FadeIn} exiting={FadeOut}>
 *   <Text>I am only animated on native</Text>
 * </NativeOnlyAnimatedView>
 */
export function NativeOnlyAnimatedView({
  children,
  ...animatedViewProps
}: React.ComponentProps<typeof Animated.View> & React.RefAttributes<Animated.View>) {
  return Platform.OS === "web" ? (
    <>{children}</>
  ) : (
    <Animated.View {...animatedViewProps}>{children}</Animated.View>
  );
}
